export const aspects = [
  { name: "Customer Service", positive: 58.3, neutral: 33.4, negative: 33.4 },
  { name: "Durability", positive: 50.0, neutral: 33.3, negative: 16.7 },
  { name: "Noisy components", positive: 50.0, neutral: 33.3, negative: 16.7 },
  { name: "Price", positive: 29.3, neutral: 68.3, negative: 2.4 },
  { name: "Quality", positive: 58.3, neutral: 25.0, negative: 16.7 },
  { name: "Quiet operation", positive: 7.3, neutral: 92.7, negative: 0.0 },
  { name: "Sleek design", positive: 8.3, neutral: 83.4, negative: 8.3 },
];
